<template>
  <div class="page">
    <div class="div-header-select">
      <div class="div-center">
        <div style="width: 60px">搜索：</div>
        <el-input
          placeholder="请输入类型名称"
          v-model="name"
           maxlength="10" 
          size="medium"
          clearable @clear="initQuery"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="initQuery"
          ></el-button>
        </el-input>
      </div>
    </div>

    <div class="div-2 div-2-top">
      <div>
        <el-button size="medium" @click="addAndUpdateHouseType()">添加</el-button>
        <!-- <el-button size="medium" @click="showTopupDialog(1)">退款</el-button> -->
      </div>
      <div></div>
    </div>

    <main>
      <el-table :data="listData"  height="calc(100vh - 200px)" style="width: 100%">
        <template slot="empty">
          <img
            src="../../assets/list-none.png"
            alt=""
            width="400"
            class="table-empty"
          />
          <div>空荡荡的～暂无数据！</div>
        </template>
        <el-table-column prop="name" label="类型名称" align="center">
        </el-table-column>
        <el-table-column  prop="pricingsName" label="收费项目" align="left">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-plus"
              plain
              size="mini"
              @click="addAndUpdateCharges(scope.row,null)">
              </el-button>
              <span v-for="pricing in scope.row.pricings" :key="pricing.id" align="center" style="padding: 5px 5px ;" >
              <el-button
              type="primary"
              round
              size="mini"
               style="padding: 5px 10px ;"
              @click="addAndUpdateCharges(scope.row,pricing)"
               >
              {{pricing.name}}
              </el-button>
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="描述" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
           <el-button
              type="primary"
              icon="el-icon-edit"
              plain
              size="mini"
              @click="addAndUpdateHouseType(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              plain
              size="mini"
              @click="deleteItem(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIdx"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="itemTotal"
        :page-sizes="[10, 20, 30, 40, 50]"
      >
      </el-pagination>
    </footer>
<!-- 添加或修改房源类型 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="this.titleType"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2">
          <div class="div-2-title">类型名称</div>
          <el-input style="width:300px;margin-right: 20px;" maxlength="10"  v-model="formInput.name"></el-input>
        </div>
        <div class="div-2">
          <!-- <div class="div-2-title">收费项目</div>
          <el-input v-model="formInput.pricingsName"></el-input> -->
        </div>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2" >
           <div class="div-2-title">描述</div>
           <el-input type="textarea"  maxlength="200" style="width:300px;margin-right: 75px;" v-model="formInput.comment"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitAdd"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加或修改收费项目 -->
    <el-dialog
      :visible.sync="pricingDialogVisible"
      :title="this.titlePricingName"
      width="25%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="div-2">
        <div class="div-2"  style="width:100%" >
          <div class="div-2-title" style="width:10%;margin-left: -25px;" >项目</div>
          <el-select v-model="pricing.id" placeholder="请选择" :disabled="this.isEdit" style="width:80%"  size="medium">
          <el-option
            v-for="item in pricingList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :change="getPricingName(item)"
          >
          </el-option>
        </el-select>
        </div>
      </div>
      <div class="div-2 div-2-top">
        <div class="div-2"   style="width:100%" >
           <div class="div-2-title" style="width:10%;margin-left: -25px;" >金额</div>
           <el-input-number :precision="this.precision"  :min="0" :max="9999999999" style="width:80%"  v-model="pricing.amount"></el-input-number>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="this.isDle" type="danger" @click="deletePricing" size="medium"
          >删 除</el-button
        >
        <el-button @click="pricingDialogVisible = false" size="medium"
          >取 消</el-button
        >
        <el-button type="primary" size="medium" @click="submitAddOrUpdatePricing"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import { Loading } from "element-ui";
import { Decimal } from "decimal.js";
import mixins from "../../minix";

let _vue;

export default {
  mixins: [mixins],
  name: "home",

  data() {
    return {
      pageIdx: 0,
      isDle:false,
      isEdit:false,
      precision:2,//收费项目金额预留小数点位数
      itemTotal: 0,
      title:'新增',
      titlePricingName:'',
      titleType:"",
      queryPhone:'',
      dialogVisible: false,
      pricingDialogVisible: false,
      listData: [],
      pricingList: [],
      pricing: {},
      name: "",
      pricings: [],

      dialogTopupVisible: false,
      house:{
        id:'',
        name:'',
        areaName:'',
      },
      formInput: {
      }
    };
  },

  created() {
    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.query(0);
    this.getPricingList();
    _vue = this;
  },

  watch: {
    state() {
      this.initQuery();
    },

    areaIDSelect() {
      this.initQuery();
    }
  },

  methods: {
    handleCurrentChange(val) {
      // eslint-disable-next-line no-console 
      this.pageIdx = val;
      this.query(val - 1);
    },

    querySearch(queryString, cb) {
      cb(this.areasList);
    },

    handleSizeChange(val) {
      // eslint-disable-next-line no-console 
      this.pageIdx = 0;
      this.pageSize = val;
      this.query(0);
    },

    editPrice(data) {
      let list = [];
      if (Array.isArray(data)) {
        data.forEach(item => {
          list.push({
            name: item.house,
            pricings: [
              {
                name: item.name,
                price: new Decimal(item.price)
                  .mul(new Decimal(10000))
                  .toNumber()
              }
            ]
          });
        });
      } else {
        list.push({
          name: data.house,
          pricings: [
            {
              name: data.name,
              price: new Decimal(data.price).mul(new Decimal(10000)).toNumber()
            }
          ]
        });
      }

      axios({
        method: "post",
        url: "meters/pricings/edit",
        data: {
          data: list
        }
      })
        .then(value => {
          let message = value.data.message;
          if (value.data.code === 0) {
            this.$message.success(message);
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        });
    },
    //删除收费项目
    deletePricing(){
      this.$confirm(
        `是否执行删除【${this.pricing.name}】项目操作？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
      //1 新增 -1删除 0修改
      this.pricing.method =-1 
      this.submitAddOrUpdatePricing()
      });
    },
    getPricingName(item){
      if (this.pricing.id == item.id) {
      this.pricing.name=item.name
      if (this.pricing.name=="水费" || this.pricing.name=="电费"){
        this.precision=4
        }else{
          this.precision=2
        }
      }
    },
    getPricingList(){
      this.pricingList=[]
      let data = {
              orgID: this.$route.query.orgID,
              pageSize: 100,
              pageIdx: 0
      };
        axios({
        method: "post",
        url: "pricings/query",
        data: data
      })
        .then(value => {
          this.pricingList =[];
          if (value && value.data && value.data.data) {
          this.pricingList =value.data.data
          }
        })
        .catch(() => {})
    },
    //添加收费项目
    submitAddOrUpdatePricing(){
        if (!this.pricing.id || this.pricing.id.length <= 0) {
          this.$message.error("请选择项目");
          return;
        }else if (!this.pricing.amount){
          if(this.pricing.amount != 0){
            this.$message.error("请输入金额");
            return;
          }
        }else if(this.pricing.amount <0){
            this.$message.error("请输入金额");
            return;
          }
        let data = { ...this.pricing };
        
        if (data.name=="电费" || data.name=="水费"){
          data.amount = new Decimal(data.amount)
                  .mul(new Decimal(10000))
                  .toNumber()
        }else{
          data.amount = new Decimal(data.amount)
                  .mul(new Decimal(100))
                  .toNumber()
        }
        
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: 'housetypes/pricings/edit',
          data: data
        })
          .then(value => {
            if (value.data.code === 0) {
              this.$message.success(value.data.message);
              this.pricingDialogVisible = false;
              this.pageIdx = 0;
              this.query(0);
            } else {
              this.$message.error(value.data.message);
            }
          })
          .catch(() => {})
          .finally(()=>{
            loading.close();
          });
    },

    submitAdd() {
      if (!this.formInput.name) {
        this.$message.error("请输入类型名称");
        return;
      }
      let data = { ...this.formInput };
      
      let url ='';
      if (this.formInput.id){
        url ="housetypes/edit"
      }else {        
        url ="housetypes/add"
      }
      if (url){
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
      axios({
        method: "post",
        url: url,
        data: data
      })
        .then(value => {
          if (value.data.code === 0) {
            this.$message.success(value.data.message);
            this.dialogVisible = false;
            this.pageIdx = 0;
            this.query(0);
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(()=>{
          loading.close();
        })
      }
    },
    deleteItem(item) {
      let _vue = this;
      this.$confirm(
        `是否删除【${item.name}】房源类型？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        
      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });
        axios({
          method: "post",
          url: "housetypes/delete",
          data: {
            id: item.id,
            name: item.name
          }
        })
          .then(value => {
             if (value.data.code === 0) {
              this.$message.success(value.data.message);
            } else {
              this.$message.error(value.data.message);
            }
          })
          .finally(() => {
            loading.close();
            _vue.query(_vue.pageIdx - 1);
          });
      });
    },
    addAndUpdateHouseType(row) {
      if (row){
        this.titleType='修改类型'
        // this.formInput = row;
        this.formInput = {
          ...row,
        }
      }else{
        this.titleType='新增类型'
        this.formInput =[]
      }
      this.dialogVisible = true;
    },
    addAndUpdateCharges(houseType,pricingtmp) {
      
      this.pricing={}
      if (pricingtmp !=null){      
        if (pricingtmp.name=="水费" || pricingtmp.name=="电费"){
        this.precision=4
        }else{
          this.precision=2
        }
        this.title='修改'
        this.titlePricingName= houseType.name+" - "+this.title+"收费项目"
        this.isEdit = true;
        this.isDle = true;
        // this.pricing=pricingtmp
        this.pricing = {
          ...pricingtmp
          // id:pricingtmp.id,
          // name:pricingtmp.name,
          // amount:pricingtmp.amount,
          }
        this.pricing.houseTypeID = houseType.id
                this.pricing.method = 0
        this.pricingDialogVisible = true;
      }else{        
        if (this.pricingList[0].name=="水费"||this.pricingList[0].name=="电费"){
        this.precision=4
        }else{
          this.precision=2
        }
        this.title='新增'
        this.titlePricingName= houseType.name+" - "+this.title+"收费项目"
        this.titleType='新增类型'
        this.isDle = false;
        this.isEdit = false;
        this.pricing.houseTypeID=houseType.id
        this.pricing.method = 1
        this.pricingDialogVisible = true;
      }
    },


    initQuery() {
      this.pageIdx = 0;
      this.query(0);
    },

    //列表查询
    query(pageIdx) {
      if (pageIdx <= 0) {
        pageIdx = 0;
      }

      let data = {
        pageSize: this.pageSize,
        pageIdx: pageIdx,
        name: this.name
      };

      const loading = Loading.service({
        lock: true,
        text: "正在请求...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: "housetypes",
        data: data
      })
        .then(value => {
          this.listData = [];
          if(value.data.code!=0){
            this.$message.error(value.data.message);
            return
          }
          this.itemTotal = value.data.total;
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.pricings.forEach(pricing => {
                if (pricing.name=="电费" || pricing.name=="水费"){
                pricing.amount = new Decimal(pricing.amount)
                        .div(new Decimal(10000))
                        .toNumber()
              }else{
                pricing.amount = new Decimal(pricing.amount)
                        .div(new Decimal(100))
                        .toNumber()
              }
              });
              
              this.listData.push(item);
            });
          }
          
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-input-group__prepend {
  width: 140px !important;
}
.el-input-group--prepend {
  margin-bottom: 10px;
}
</style>

<style lang="scss" scoped>
@import "../../style.css";
main {
  margin-top: 10px;
}
.div-2-title {
  max-width: 80px;
  min-width: 70px;
}
</style>